import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const projectUrl = import.meta.env.VITE_APPCRADLE_AUTH_URL?.trim().replace(/\/$/, "");
const publishableKey = import.meta.env.VITE_APPCRADLE_AUTH_PUBLISHABLE_KEY?.trim();
const projectRef = import.meta.env.VITE_APPCRADLE_AUTH_PROJECT_REF?.trim();

function hasExpectedProjectPath(url: string, ref: string): boolean {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "https:" && parsed.pathname.replace(/\/$/, "") === `/project/${ref}`;
  } catch {
    return false;
  }
}

export const authConfigured = Boolean(
  projectUrl
  && publishableKey
  && projectRef
  && !projectUrl.includes("YOUR_PROJECT_REF")
  && !publishableKey.includes("YOUR_PUBLISHABLE_KEY")
  && !projectRef.includes("YOUR_PROJECT_REF")
  && /^(?:aca|ea)_publishable_/.test(publishableKey)
  && hasExpectedProjectPath(projectUrl, projectRef)
);

let clientPromise: Promise<SupabaseClient> | null = null;

export async function getAuthClient(): Promise<SupabaseClient | null> {
  if (!authConfigured || !projectUrl || !publishableKey || !projectRef) return null;
  clientPromise ??= Promise.resolve(createClient(projectUrl, publishableKey, {
    auth: {
      storageKey: `appcradle-auth-${projectRef}`,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true
    }
  }));
  return clientPromise;
}
